// Copyright (c) Move Closer 2022.

import { SearchResultsConfig } from '../../../contexts'

import { SearchResultItemTab } from '../../shared/services/search'
import { SearchResultLatestItem, searchResultLatestResolver } from '../../shared/molecules/SearchResultLatestItem'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const latestResultPreview: SearchResultsConfig = {
  latest: {
    label: 'some.key.to.translations.latest',
    component: SearchResultLatestItem
  }
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const latestResultConfig: SearchResultItemTab[] = [{
  label: 'some.key.to.translations.latest',
  value: 'results',
  priority: 100,
  preview: latestResultPreview,
  resolver: searchResultLatestResolver
}]

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const SEARCH_RESULTS_VIEW_KEY = 'SearchResultsView'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const SEARCH_RESULTS_DEFAULT_CONFIG = {
  hasControls: false,
  resultsPerPage: 8,
  usePerPageParam: true,
  useRouteParams: false
}
